import { IOBOAccount } from '../../models/obo-account';
import { IResult } from '../../models/result-models';
import { LOAD_OBO_ACCOUNTS_SUCCESS } from './obo-actions';

interface LoadOBOAccountsAction {
    type: 'LOAD_OBO_ACCOUNTS_SUCCESS';
    result: IResult<IOBOAccount>;
}

type KnownAction = LoadOBOAccountsAction;

export const OBOReducer = (
    state: IResult<IOBOAccount> | null | undefined = null,
    action: KnownAction
) => {
    switch (action.type) {
        case LOAD_OBO_ACCOUNTS_SUCCESS:
            return action.result;
        default:
            return state;
    }
};
